import PubSub from "underpub-js";

var Availability = function(options) {

	this.options = {
		$el: false,
		baseClass: 'layout-Availability',
	};

	$.extend(true, this.options, options);

};

Availability.prototype.init = function() {

	var self = this;

};

export default Availability;
